import 'regenerator-runtime/runtime';

export const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.addEventListener("error", reject);
    script.addEventListener("load", resolve);
    document.body.appendChild(script);
  });
};

export const loadLink = (url) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    link.addEventListener("error", reject);
    link.addEventListener("load", resolve);
    document.body.appendChild(link);
  });
};

export const serialize = (data) => {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
}

export const isMatching = (term, search) => {
  if (term.length > 0 && search.length > 0) {
    const letters = [...term.toLowerCase()];
    return letters.slice(0, search.length).every((letter, index) => letter === search[index].toLowerCase())
  }
  return false;
};

export const siblingWithClass = (currentEle, className) => {
  let nextSibling = currentEle.nextElementSibling;
  while(nextSibling) {
      if(nextSibling.classList.contains(className)){
        return nextSibling
      }
      nextSibling = nextSibling.nextElementSibling;
  }
}

export const RECAPTCHA__SITE__KEY = '6Ldy7pwbAAAAAIi_KeC0mgU9lD5BqANHxmIaOTmF';

// Function that loads recaptcha on form input focus
export const loadReCaptcha =  () => {
  if(!document.getElementById("recaptcha-library")) {
    var head = document.getElementsByTagName('head')[0]
    var script = document.createElement('script')
    script.id = "recaptcha-library"
    script.type = 'text/javascript';
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit`
    head.appendChild(script);
  
    // remove focus to avoid js error:
    const recaptchaInputs = document.querySelectorAll(".sd__input-recaptcha");
    [...recaptchaInputs].forEach((input) => {
      input.removeEventListener('focus', loadReCaptcha);
    })
  }
 };

 export const getRecaptcha = async(cID, tINPUT) => {  
  return new Promise((res, rej) => {
    const container = document.getElementById(cID);
    if (container !== null) {
      var config = grecaptcha.render(cID, {
        'sitekey': RECAPTCHA__SITE__KEY,
        'badge': 'inline',
        'size': 'invisible'
      });

      grecaptcha.ready(function () {
        grecaptcha.execute(config,
          {
            action: 'submit'
          })
          .then(function (token) {
            const input = document.querySelector(tINPUT)     
            input.value = token;
            return res(token);
          });
      })
    }
  })
 }
